import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../Customize_Css/AddVendor.css";
import Sidebar from "../Components/Siderbar";
import Footer from "../Components/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddEmployee = () => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const epicxTenantId = localStorage.getItem("epicxTenantId");
  const AuthorizationToken = localStorage.getItem("token");

  const [formData, setFormData] = useState({
    employeeName: "",
    phoneNumber: "",
    emailId: "",
    password: "",
    designation: "",
    department: "",
    gender: "",
    city: "",
    address: "",
    hireDate: "",
    tenantId: epicxTenantId || "",
  });

  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === 'phoneNumber' && !/^\d*$/.test(value)) return;
    setFormData({ ...formData, [id]: value });
    validateField(id, value);
  };

  const validateField = (id, value) => {
    const validationRules = {
      employeeName: { message: "Employee Name is required", validator: (val) => val.trim() !== "" },
      phoneNumber: { message: "Valid Phone Number is required (10 digits)", validator: (val) => /^\d{10}$/.test(val) },
      emailId: { message: "Valid Email ID is required", validator: (val) => /\S+@\S+\.\S+/.test(val) },
      password: { message: "Password is required (min 6 characters)", validator: (val) => val.length >= 6 },
      designation: { message: "Designation is required", validator: (val) => val.trim() !== "" && val !== "Select Designation" },
      department: { message: "Department is required", validator: (val) => val.trim() !== "" && val !== "Select Department" },
      gender: { message: "Gender is required", validator: (val) => val.trim() !== "" && val !== "Select Gender" },
      city: { message: "City is required", validator: (val) => val.trim() !== "" },
      address: { message: "Address is required", validator: (val) => val.trim() !== "" },
      hireDate: { message: "Hire Date is required", validator: (val) => val.trim() !== "" },
    };

    const rule = validationRules[id];
    if (!rule) return;

    const isValid = rule.validator(value);
    setErrors((prev) => (isValid ? { ...prev, [id]: "" } : { ...prev, [id]: rule.message }));
    setValidFields((prev) => (isValid ? { ...prev, [id]: true } : { ...prev, [id]: false }));
  };

  const validateForm = () => {
    let isValid = true;
    Object.keys(formData).forEach((key) => {
      if (key === "tenantId") return; // Skip validation for tenantId
      validateField(key, formData[key]);
      if (errors[key]) isValid = false;
    });
    if (!formData.tenantId) {
      toast.error("Tenant ID is missing. Please ensure you are logged in.");
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fix the errors in the form");
      return;
    }
    try {
      console.log("Submitting formData:", formData);
      console.log("Request URL:", `${BASE_URL}/login/api/login/employee/register`); // Debug log
      const response = await fetch(`${BASE_URL}/login/api/login/employee/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Employee added successfully");
        setFormData({
          employeeName: "",
          phoneNumber: "",
          emailId: "",
          password: "",
          designation: "",
          department: "",
          gender: "",
          city: "",
          address: "",
          hireDate: "",
          tenantId: epicxTenantId || "",
        });
        setErrors({});
        setValidFields({});
      } else {
        toast.error(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error adding employee:", error);
      toast.error("Failed to add employee. Please try again.");
    }
  };

  const handleCancel = () => {
    setFormData({
      employeeName: "",
      phoneNumber: "",
      emailId: "",
      password: "",
      designation: "",
      department: "",
      gender: "",
      city: "",
      address: "",
      hireDate: "",
      tenantId: epicxTenantId || "",
    });
    setErrors({});
    setValidFields({});
  };

  // Define options for designation and department dropdowns suitable for B2C admin employees
  const designationOptions = [
    "Select Designation",
    "Admin Manager",
    "Customer Support Lead",
    "Sales Administrator",
    "Marketing Coordinator",
    "Operations Supervisor"
  ];

  const departmentOptions = [
    "Select Department",
    "Administration",
    "Customer Support",
    "Sales",
    "Marketing",
    "Operations"
  ];

  return (
    <>
      <Sidebar />
      <div className="vendor-form-page">
        <div className="vendor-form-shell">
          <header className="vendor-form-hero">
            <div>
              <p className="vendor-form-kicker">People</p>
              <h1>Add Employee</h1>
              <p>Enter name, contact, role, and hire date. Required fields stay the same.</p>
            </div>
            <button type="button" className="vendor-form-back-btn" onClick={() => navigate('/view-employee')}>Back to Employees</button>
          </header>
          <div className="vendor-form-card">
            <div className="vendor-form-card-head">
              <div>
                <h2>Employee Information</h2>
                <p>Contact, designation, department, and address.</p>
              </div>
            </div>
            <div className="vendor-form-card-body">
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="employeeName">Employee Name <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    className={`form-control bg-light ${errors.employeeName ? "is-invalid" : validFields.employeeName ? "is-valid" : ""}`}
                    id="employeeName"
                    value={formData.employeeName}
                    onChange={handleChange}
                  />
                  {errors.employeeName && <small className="text-danger">{errors.employeeName}</small>}
                </div>
                <div className="col-md-4">
                  <label htmlFor="phoneNumber">Phone Number <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    className={`form-control bg-light ${errors.phoneNumber ? "is-invalid" : validFields.phoneNumber ? "is-valid" : ""}`}
                    id="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    maxLength={10}
                    inputMode="numeric"
                  />
                  {errors.phoneNumber && <small className="text-danger">{errors.phoneNumber}</small>}
                </div>
                <div className="col-md-4">
                  <label htmlFor="emailId">Email ID <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="email"
                    className={`form-control bg-light ${errors.emailId ? "is-invalid" : validFields.emailId ? "is-valid" : ""}`}
                    id="emailId"
                    value={formData.emailId}
                    onChange={handleChange}
                  />
                  {errors.emailId && <small className="text-danger">{errors.emailId}</small>}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-4">
                  <label htmlFor="password">Password <span style={{ color: "red" }}>*</span></label>
                  <div className={`d-flex align-items-center bg-light ${errors.password ? "is-invalid border border-danger" : validFields.password ? "border border-success" : "border"}`} style={{ borderRadius: '0.375rem', overflow: 'hidden' }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="bg-light border-0 flex-grow-1"
                      id="password"
                      value={formData.password}
                      onChange={handleChange}
                      style={{ outline: 'none', padding: '0.375rem 0.75rem', minWidth: 0 }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(v => !v)}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', padding: '0 10px', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                    >
                      {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                    </button>
                  </div>
                  {errors.password && <small className="text-danger">{errors.password}</small>}
                </div>
                {/* Changed designation input to dropdown for B2C admin roles */}
                <div className="col-md-4">
                  <label htmlFor="designation">Designation <span style={{ color: "red" }}>*</span></label>
                  <select
                    className={`form-control bg-light ${errors.designation ? "is-invalid" : validFields.designation ? "is-valid" : ""}`}
                    id="designation"
                    value={formData.designation}
                    onChange={handleChange}
                  >
                    {designationOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  {errors.designation && <small className="text-danger">{errors.designation}</small>}
                </div>
                {/* Changed department input to dropdown for B2C admin departments */}
                <div className="col-md-4">
                  <label htmlFor="department">Department <span style={{ color: "red" }}>*</span></label>
                  <select
                    className={`form-control bg-light ${errors.department ? "is-invalid" : validFields.department ? "is-valid" : ""}`}
                    id="department"
                    value={formData.department}
                    onChange={handleChange}
                  >
                    {departmentOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                  {errors.department && <small className="text-danger">{errors.department}</small>}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-4">
                  <label htmlFor="gender">Gender <span style={{ color: "red" }}>*</span></label>
                  <select
                    className={`form-control bg-light ${errors.gender ? "is-invalid" : validFields.gender ? "is-valid" : ""}`}
                    id="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option>Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                  {errors.gender && <small className="text-danger">{errors.gender}</small>}
                </div>
                <div className="col-md-4">
                  <label htmlFor="city">City <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    className={`form-control bg-light ${errors.city ? "is-invalid" : validFields.city ? "is-valid" : ""}`}
                    id="city"
                    value={formData.city}
                    onChange={handleChange}
                  />
                  {errors.city && <small className="text-danger">{errors.city}</small>}
                </div>
                <div className="col-md-4">
                  <label htmlFor="hireDate">Hire Date <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="date"
                    className={`form-control bg-light ${errors.hireDate ? "is-invalid" : validFields.hireDate ? "is-valid" : ""}`}
                    id="hireDate"
                    value={formData.hireDate}
                    onChange={handleChange}
                  />
                  {errors.hireDate && <small className="text-danger">{errors.hireDate}</small>}
                </div>
                <div className="col-md-4">
                  <label htmlFor="address">Address <span style={{ color: "red" }}>*</span></label>
                  <textarea
                    className={`form-control bg-light ${errors.address ? "is-invalid" : validFields.address ? "is-valid" : ""}`}
                    id="address"
                    rows="2"
                    value={formData.address}
                    onChange={handleChange}
                  ></textarea>
                  {errors.address && <small className="text-danger">{errors.address}</small>}
                </div>
              </div>
              <div className="row mt-3">
              </div>
            </div>
          </div>
          <div className="vendor-form-actions">
            <button type="button" className="vendor-form-cancel" onClick={handleCancel}>Cancel</button>
            <button type="button" className="vendor-form-submit" onClick={handleSubmit}>Save and Submit</button>
          </div>
        </div>
        <div className="vendor-form-footer">
          <Footer />
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }}
      />
    </>
  );
};

export default AddEmployee;

// import React, { useState } from "react";
// import Sidebar from "../Components/Siderbar";
// import Footer from "../Components/Footer";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const AddEmployee = () => {
//   const BASE_URL = process.env.REACT_APP_BASE_URL;
//   const epicxTenantId = localStorage.getItem("epicxTenantId");
//   const AuthorizationToken = localStorage.getItem("token");

//   const [formData, setFormData] = useState({
//     employeeName: "",
//     phoneNumber: "",
//     emailId: "",
//     password: "",
//     designation: "",
//     department: "",
//     gender: "",
//     city: "",
//     address: "",
//     hireDate: "",
//     tenantId: epicxTenantId || "",
//   });

//   const [errors, setErrors] = useState({});
//   const [validFields, setValidFields] = useState({});

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//     validateField(id, value);
//   };

//   const validateField = (id, value) => {
//     const validationRules = {
//       employeeName: { message: "Employee Name is required", validator: (val) => val.trim() !== "" },
//       phoneNumber: { message: "Valid Phone Number is required (10 digits)", validator: (val) => /^\d{10}$/.test(val) },
//       emailId: { message: "Valid Email ID is required", validator: (val) => /\S+@\S+\.\S+/.test(val) },
//       password: { message: "Password is required (min 6 characters)", validator: (val) => val.length >= 6 },
//       designation: { message: "Designation is required", validator: (val) => val.trim() !== "" },
//       department: { message: "Department is required", validator: (val) => val.trim() !== "" },
//       gender: { message: "Gender is required", validator: (val) => val.trim() !== "" && val !== "Select Gender" },
//       city: { message: "City is required", validator: (val) => val.trim() !== "" },
//       address: { message: "Address is required", validator: (val) => val.trim() !== "" },
//       hireDate: { message: "Hire Date is required", validator: (val) => val.trim() !== "" },
//     };

//     const rule = validationRules[id];
//     if (!rule) return;

//     const isValid = rule.validator(value);
//     setErrors((prev) => (isValid ? { ...prev, [id]: "" } : { ...prev, [id]: rule.message }));
//     setValidFields((prev) => (isValid ? { ...prev, [id]: true } : { ...prev, [id]: false }));
//   };

//   const validateForm = () => {
//     let isValid = true;
//     Object.keys(formData).forEach((key) => {
//       if (key === "tenantId") return; // Skip validation for tenantId
//       validateField(key, formData[key]);
//       if (errors[key]) isValid = false;
//     });
//     if (!formData.tenantId) {
//       toast.error("Tenant ID is missing. Please ensure you are logged in.");
//       isValid = false;
//     }
//     return isValid;
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) {
//       toast.error("Please fix the errors in the form");
//       return;
//     }
//     try {
//       console.log("Submitting formData:", formData);
//       console.log("Request URL:", `${BASE_URL}/login/api/login/employee/register`); // Debug log
//       const response = await fetch(`${BASE_URL}/login/api/login/employee/register`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${AuthorizationToken}`,
//         },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         toast.success("Employee added successfully");
//         setFormData({
//           employeeName: "",
//           phoneNumber: "",
//           emailId: "",
//           password: "",
//           designation: "",
//           department: "",
//           gender: "",
//           city: "",
//           address: "",
//           hireDate: "",
//           tenantId: epicxTenantId || "",
//         });
//         setErrors({});
//         setValidFields({});
//       } else {
//         toast.error(`Error: ${result.message}`);
//       }
//     } catch (error) {
//       console.error("Error adding employee:", error);
//       toast.error("Failed to add employee. Please try again.");
//     }
//   };

//   const handleCancel = () => {
//     setFormData({
//       employeeName: "",
//       phoneNumber: "",
//       emailId: "",
//       password: "",
//       designation: "",
//       department: "",
//       gender: "",
//       city: "",
//       address: "",
//       hireDate: "",
//       tenantId: epicxTenantId || "",
//     });
//     setErrors({});
//     setValidFields({});
//   };

//   return (
//     <>
//       <Sidebar />
//       <div style={{ height: "92vh", overflowY: "auto", width: "100%" }}>
//         <div className="container">
//           <h5 style={{ padding: "20px" }}>Add Employee</h5>
//           <div className="card">
//             <div className="card-header bg-light">
//               <h5>Employee Information</h5>
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="col-md-4">
//                   <label htmlFor="employeeName">Employee Name <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="text"
//                     className={`form-control bg-light ${errors.employeeName ? "is-invalid" : validFields.employeeName ? "is-valid" : ""}`}
//                     id="employeeName"
//                     value={formData.employeeName}
//                     onChange={handleChange}
//                   />
//                   {errors.employeeName && <small className="text-danger">{errors.employeeName}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="phoneNumber">Phone Number <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="text"
//                     className={`form-control bg-light ${errors.phoneNumber ? "is-invalid" : validFields.phoneNumber ? "is-valid" : ""}`}
//                     id="phoneNumber"
//                     value={formData.phoneNumber}
//                     onChange={handleChange}
//                   />
//                   {errors.phoneNumber && <small className="text-danger">{errors.phoneNumber}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="emailId">Email ID <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="email"
//                     className={`form-control bg-light ${errors.emailId ? "is-invalid" : validFields.emailId ? "is-valid" : ""}`}
//                     id="emailId"
//                     value={formData.emailId}
//                     onChange={handleChange}
//                   />
//                   {errors.emailId && <small className="text-danger">{errors.emailId}</small>}
//                 </div>
//               </div>
//               <div className="row mt-3">
//                 <div className="col-md-4">
//                   <label htmlFor="password">Password <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="password"
//                     className={`form-control bg-light ${errors.password ? "is-invalid" : validFields.password ? "is-valid" : ""}`}
//                     id="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                   />
//                   {errors.password && <small className="text-danger">{errors.password}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="designation">Designation <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="text"
//                     className={`form-control bg-light ${errors.designation ? "is-invalid" : validFields.designation ? "is-valid" : ""}`}
//                     id="designation"
//                     value={formData.designation}
//                     onChange={handleChange}
//                   />
//                   {errors.designation && <small className="text-danger">{errors.designation}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="department">Department <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="text"
//                     className={`form-control bg-light ${errors.department ? "is-invalid" : validFields.department ? "is-valid" : ""}`}
//                     id="department"
//                     value={formData.department}
//                     onChange={handleChange}
//                   />
//                   {errors.department && <small className="text-danger">{errors.department}</small>}
//                 </div>
//               </div>
//               <div className="row mt-3">
//                 <div className="col-md-4">
//                   <label htmlFor="gender">Gender <span style={{ color: "red" }}>*</span></label>
//                   <select
//                     className={`form-control bg-light ${errors.gender ? "is-invalid" : validFields.gender ? "is-valid" : ""}`}
//                     id="gender"
//                     value={formData.gender}
//                     onChange={handleChange}
//                   >
//                     <option>Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                   {errors.gender && <small className="text-danger">{errors.gender}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="city">City <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="text"
//                     className={`form-control bg-light ${errors.city ? "is-invalid" : validFields.city ? "is-valid" : ""}`}
//                     id="city"
//                     value={formData.city}
//                     onChange={handleChange}
//                   />
//                   {errors.city && <small className="text-danger">{errors.city}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="hireDate">Hire Date <span style={{ color: "red" }}>*</span></label>
//                   <input
//                     type="date"
//                     className={`form-control bg-light ${errors.hireDate ? "is-invalid" : validFields.hireDate ? "is-valid" : ""}`}
//                     id="hireDate"
//                     value={formData.hireDate}
//                     onChange={handleChange}
//                   />
//                   {errors.hireDate && <small className="text-danger">{errors.hireDate}</small>}
//                 </div>
//                 <div className="col-md-4">
//                   <label htmlFor="address">Address <span style={{ color: "red" }}>*</span></label>
//                   <textarea
//                     className={`form-control bg-light ${errors.address ? "is-invalid" : validFields.address ? "is-valid" : ""}`}
//                     id="address"
//                     rows="2"
//                     value={formData.address}
//                     onChange={handleChange}
//                   ></textarea>
//                   {errors.address && <small className="text-danger">{errors.address}</small>}
//                 </div>
//               </div>
//               <div className="row mt-3">
               
//               </div>
//             </div>
//           </div>
//           <div
//             className="row"
//             style={{
//               backgroundColor: "#e5e5e5",
//               padding: "10px",
//               marginBottom: "-1.5%",
//               marginTop: "6.6%",
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <div className="col text-start">
//               <button className="btn" style={{ backgroundColor: "white", color: "black" }} onClick={handleCancel}>
//                 Cancel
//               </button>
//             </div>
//             <div className="col text-end">
//               <button className="btn btn-success" onClick={handleSubmit}>
//                 Save and Submit
//               </button>
//             </div>
//           </div>
//         </div>
//         <div style={{ marginTop: "1.7%" }}>
//           <Footer />
//         </div>
//       </div>
//       <ToastContainer
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={true}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         style={{ zIndex: 9999 }}
//       />
//     </>
//   );
// };

// export default AddEmployee;
